import { IRegisterType } from 'APIPackage/CatalogsModule/interfaces/IRegisterType';

import { IRegisterTypeSelectOption } from '../interfaces/IRegistryTypeSelectOption';

export function createRegisterTypesSelectOption(type: IRegisterType): IRegisterTypeSelectOption {
  return {
    ...type,
    id: type.id,
    label: type.title,
    value: type.id,
    enabled: true,
  };
}
